var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,_vm._g(_vm._b({tag:"component",model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'component',_vm.attrs,false),_vm.on)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }